// F-105b: a YouTube link in the specialist's text gets a tile of OUR OWN (no YouTube image, no request) that swaps to the privacy-enhanced player only when tapped.
// Nothing leaves the app until the tap: the iframe (https://www.youtube-nocookie.com/embed/<id>) is created in the click handler, never at render.
const T = (k, p) => window.HUD?.T?.(k, p) || k;
const YT_ID = /^[A-Za-z0-9_-]{11}$/;
export const YT_EMBED = id => `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;

export function makeYoutubeTile(id, doc = document) {
  if (!YT_ID.test(String(id))) return null;                                    // only a well-formed 11-character id ever reaches the embed URL
  const b = doc.createElement('button'); b.type = 'button'; b.className = 'hwp-yt';
  b.setAttribute('aria-label', T('hw5_watch_first'));                           // the existing approved string
  b.innerHTML = '<span class="hwp-yt-play" aria-hidden="true"></span><span class="hwp-yt-tag" aria-hidden="true">YouTube</span>';
  b.onclick = () => {
    const f = doc.createElement('iframe'); f.className = 'hwp-yt-frame';
    f.src = YT_EMBED(id); f.title = 'YouTube';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    f.setAttribute('allowfullscreen', ''); f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    f.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox');
    b.replaceWith(f);
  };
  return b;
}
